import dompurify from "isomorphic-dompurify";

import { useCheckoutConfiguration } from "@jti/commerce/providers";
import type { PaymentData } from "@jti/fe-common";
import { customPaymentMethods } from "@jti/fe-common";
import { useSelector } from "@jti/store/reduxHooks";
import { useTranslations } from "@jti/ui";

import styles from "./OrderView.module.scss";

const { sanitize } = dompurify;

type OrderPaymentMethodType = {
  paymentMethod?: Pick<PaymentData, "icon" | "title" | "payment_method">;
};

const OrderPaymentMethod = ({ paymentMethod }: OrderPaymentMethodType) => {
  const { __ } = useTranslations();
  const checkoutConfiguration = useCheckoutConfiguration();
  const isPayOnDeliveryOrder = useSelector(
    (state) => state.order.orderDetails.data?.paymentMethod === customPaymentMethods.payOnDelivery
  );
  const paymentMethodTranslationKey = paymentMethod?.payment_method ?? paymentMethod?.title;
  const translatedPaymentMethodTitle =
    __(`cart.order.payment_method.${paymentMethodTranslationKey}`, undefined, paymentMethod?.title) ||
    paymentMethod?.title;

  if (isPayOnDeliveryOrder) {
    return (
      <div
        data-testid="pay-on-delivery-message"
        dangerouslySetInnerHTML={{
          __html: sanitize(checkoutConfiguration.payOnDelivery.paymentMethod),
        }}
      ></div>
    );
  }

  if (paymentMethod) {
    return (
      <div data-testid="payment-method" className={styles.paymentMethod}>
        {paymentMethod.icon && <img src={paymentMethod.icon} alt="" className={styles.paymentMethodImg} />}
        {translatedPaymentMethodTitle}
      </div>
    );
  }

  return <div>{__("cart.order.payment_method.na")}</div>;
};

export default OrderPaymentMethod;
